<script setup>

import { defineProps, defineEmits} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "pedidoDeCompra"
]);

const emits = defineEmits([
    "update:alteraObservacaoParaCancelamento",
]);

//==================================================================//
//=============== Altera Observação para Cancelamento ==============//
//==================================================================//

const alteraObservacaoParaCancelamento = (observacaoParaCancelamento) =>{

    emits('update:alteraObservacaoParaCancelamento',observacaoParaCancelamento);

};

//==================================================================//
//============= Ao Altera Observação para Cancelamento =============//
//==================================================================//

const aoAlterarObservacaoParaCancelamento = (observacaoParaCancelamento) =>{

    alteraObservacaoParaCancelamento(observacaoParaCancelamento)

};

</script>

<template>

  <v-card
        class="c-observacao-para-cancelamento"
    >

        <v-card-title
            class="c-observacao-para-cancelamento__titulo"
        >
        
            <h3>Observação para Cancelamento</h3>

        </v-card-title>

        <div
            class="c-observacao-para-cancelamento__texto"
        >

            <v-textarea
                class="c-observacao-para-cancelamento__text-area"
                :value="props?.observacaoParaCancelamento"
                label="Observação para Cancelamento"
                variant="outlined"
                no-resize
                outlined
                auto-grow
                :disabled="props.controlesDesativados"
                @input="aoAlterarObservacaoParaCancelamento"
            >
            </v-textarea>

        </div>

    </v-card>

</template>

<style scoped>

</style>


